import React, { useState } from 'react';
import { beforeAfterGallery } from '../mock';
import { MoveHorizontal } from 'lucide-react';

const BeforeAfter = () => {
  const [sliderPositions, setSliderPositions] = useState(
    beforeAfterGallery.reduce((acc, item) => ({ ...acc, [item.id]: 50 }), {})
  );

  const handleSliderChange = (id, value) => {
    setSliderPositions(prev => ({ ...prev, [id]: value }));
  };

  return (
    <section id="portfolio" className="py-20 bg-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Before & <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">After</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            See the incredible transformations we deliver
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beforeAfterGallery.map((item, index) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Before/After Comparison */}
              <div className="relative aspect-[4/3] overflow-hidden">
                {/* After Image (Full) */}
                <img
                  src={item.after}
                  alt="After"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                
                {/* Before Image (Clipped) */}
                <div
                  className="absolute inset-0 overflow-hidden"
                  style={{ clipPath: `inset(0 ${100 - sliderPositions[item.id]}% 0 0)` }}
                >
                  <img
                    src={item.before}
                    alt="Before"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>

                {/* Slider Control */}
                <div
                  className="absolute inset-y-0 w-1 bg-white shadow-lg cursor-ew-resize"
                  style={{ left: `${sliderPositions[item.id]}%` }}
                >
                  {/* Slider Handle */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center shadow-xl group-hover:scale-125 transition-transform duration-300">
                    <MoveHorizontal className="w-5 h-5 text-white" />
                  </div>
                </div>

                {/* Labels */}
                <div className="absolute top-4 left-4 bg-black/70 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-bold">
                  Before
                </div>
                <div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                  After
                </div>

                {/* Interactive Slider Input */}
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={sliderPositions[item.id]}
                  onChange={(e) => handleSliderChange(item.id, parseInt(e.target.value))}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-10"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Additional Images Grid */}
        <div className="mt-16">
          <h3 className="text-3xl font-bold text-white text-center mb-8">
            Transformation <span className="text-orange-500">Showcase</span>
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=400',
              'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=400',
              'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=400',
              'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400',
              'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400',
              'https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?w=400',
              'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400',
              'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=400'
            ].map((img, idx) => (
              <div
                key={idx}
                className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer transform hover:scale-105 transition-all duration-300"
              >
                <img
                  src={img}
                  alt={`Detail work ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
